import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { DocumentTemplate } from '../models/document-template.model';
import { environment } from '../../../environments/environment';
import { EmailChannel } from '../models';
@Injectable({
    providedIn: 'root'
})
export class EmailChannelService {
    constructor(private http: HttpClient, private apiService: ApiService) { }
    public getDistributionEmailSettings(): Observable<any> {
        return this.apiService.get(`DistributionEmailSettings/GetAll`);
    }
    public getDistributionEmailById(id): Observable<any> {
        return this.apiService.get(`DistributionEmailSettings/${id}`);
    }
    public putDistributionEmailById(id:number,distributionEmailSettings:EmailChannel): Observable<any> {
        alert('in');
        return this.apiService.put(`DistributionEmailSettings/${id}`,distributionEmailSettings);
    }
}